










































































import Vue from "vue";
import Component from "vue-class-component";
import func from "@/ts/FormFunctions";
import api from "@/ts/functions";
import fieldData from "@/ts/FormData";
import ErrorMessages from "@/ts/constants/ReportingErrorMessages";
import AddressInfo from '@/views/shared/AddressInfo.vue';
import { IVueStateCollection } from "@/ts/FormBuilder";
import ReportingPeriod from '@/views/reporting/ReportingPeriod.vue';
import { ITransferStationVueModel } from "@/ts/models/ITransferStationVueModel";
import VueSimpleSuggest from 'vue-simple-suggest/dist/cjs';

@Component({
    props: {
        form: {
            type: Object as () => ITransferStationVueModel
        },
        vueStates: {
            type: Object as () => IVueStateCollection
        },
        isReadOnly: {
            type: Boolean
        }
    },
    components: {
        AddressInfo, ReportingPeriod, VueSimpleSuggest
    }
})
export default class TransferStationFacilityInfo extends Vue {
    name: string = "TransferStationFacilityInfo";
    title: string = "";

    hasAddressError: boolean = false;
    isReportingPeriodError: boolean = false;
    errorMsgs = ErrorMessages;

    disableFacility: boolean = true;
    facility: any = null;
    facilities: any = null;
    facilitiesDb: any = null;

    beforeMount() {
        api.getFacilities("MSW Transfer Station")
            .then(res => {
                this.facilitiesDb = res;
                this.facilitiesDb = this.facilitiesDb.data;
                this.facilities = this.facilitiesDb.map((f: any) => f.facilityName);
                this.facilities = this.facilities.map(Function.prototype.call, String.prototype.trim)
            });
    }

    mounted() {
        this.title = this.$props.vueStates.views[0].name;

        this.$emit("update:title", this.title);
        this.$emit("update:currentIndex", 0);

        this.$watch("hasErrors", (n, o) => {
            this.$props.vueStates.views[0].error = this.hasErrors;
        }, { immediate: true });

        this.$watch("form.facilityNameSelect", (n, o) => {
            if (this.facilitiesDb == null) {
                return;
            }

            var objectId = this.$props.form.facilityNameSelect.substring(this.$props.form.facilityNameSelect.lastIndexOf('-') + 2);

            var facilityAddress = null;
            this.facility = this.facilitiesDb.find((f: any) => f.objectId == objectId);

            if (this.facility == null) {
                facilityAddress = fieldData.emptyAddress[0];
            } else {
                this.$props.form.facilityName = this.facility.facilityName;
                facilityAddress = this.facility.address;
            }
            if (facilityAddress != null) {
                this.$props.form.facilityAddress = facilityAddress;
                if (facilityAddress != fieldData.emptyAddress[0] && this.facility != null) {
                    this.$props.form.facilityId = this.facility.objectId;
                    this.$props.form.facilityRefId = this.facility.facilityId;
                }
            } else {
                //this.$props.form.facilityAddress = fieldData.emptyAddress[0];
            }
        }, { immediate: true });

        this.$props.vueStates.views[0].visited = true;
    }

    get isFacilityNameError(): boolean {
        return func.isNullOrEmpty(this.$props.form.facilityName)
    }
    get isHaulerError(): boolean {
        return func.isNullOrEmpty(this.$props.form.isHauler)
    }   

    get isReportingYearError(): boolean {
        return this.$props.form.reportingPeriod == null
    }

    get hasErrors(): boolean {
        return this.isFacilityNameError || this.hasAddressError || this.isReportingPeriodError || this.isHaulerError || this.isReportingYearError;
    }
}
